/*
* 数据预处理 设备的所有数据预处理列表写在此处  2023-11-29
*/

// 从设备列表项中将监测点 架构等信息分割出来
export const deviceListCarrierPreHandle = function (row) {
  if (!row.carrierName) { return [] }
  const carrier = row.carrierName.split(',')
  // 架构列表
  const sceneList = row.sceneName.split(',')
  const result = []
  carrier.forEach((item, index) => {
    const info = item.split('-')
    // index对应关系  [0]-carrierId [1]carrierType [2]carrierName
    result.push({
      id: info[0],
      type: info[1],
      carrierName: info[2],
      sceneName: sceneList[index]
    })
  })
  return result
}
